import { FC } from 'react';
// components
import EditProductFormulationTypeComponent from 'components/main/ProductFormulationType/Edit';

const EditProductFormulationType: FC = () => <EditProductFormulationTypeComponent />;

export default EditProductFormulationType;
